import type { PayloadAction } from '@reduxjs/toolkit';

import { SET_GUIDE, type Guide } from './types';

const initialState: Guide | null = null;

export function guideReducer(state = initialState, action: PayloadAction<Guide | null>): Guide | null {
	switch (action.type) {
		case SET_GUIDE:
			return action.payload;
		default:
			return state;
	}
}
